import { useState, useEffect } from 'react'

export const BASE_IMAGE_WIDTH = 280
export const BASE_IMAGE_HEIGHT = 210

type ImageData = {
  url: string
  width: number
  height: number
}

function useImageSizes(
  urls: string[],
  fixedWidth?: number,
): ImageData[] | undefined {
  const [imagesData, setImagesData] = useState<ImageData[]>()

  useEffect(() => {
    if (!urls || urls.length === 0) {
      setImagesData([])
      return
    }

    const loadImages = async (): Promise<void> => {
      const promises = urls.map<Promise<ImageData>>(
        (url) =>
          new Promise((resolve) => {
            const img = new Image()
            img.src = url

            img.onload = (): void => {
              const aspectRatio = img.height / img.width
              const calculatedWidth = fixedWidth ?? img.width
              const calculatedHeight = calculatedWidth * aspectRatio

              resolve({ url, width: calculatedWidth, height: calculatedHeight })
            }

            img.onerror = (): void =>
              resolve({
                url,
                width: BASE_IMAGE_WIDTH,
                height: BASE_IMAGE_HEIGHT,
              })
          }),
      )

      const results = await Promise.all(promises)

      setImagesData(results)
    }

    loadImages()
  }, [fixedWidth, urls])

  return imagesData
}

export { useImageSizes }

export default useImageSizes
